import { render } from "./RevenueGrowth.vue?vue&type=template&id=7314983b&scoped=true"
const script = {}

import "./RevenueGrowth.vue?vue&type=style&index=0&id=7314983b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7314983b"]])

export default __exports__